/* eslint-disable */
// eslint conflicts in auto vue create config
import Vue from "vue";
import axios from "axios";
import keysToCamelCase from "camelcase-keys";
import { getAccessToken, logOut, setTokenData } from "~/helpers/userAuth";

const config = {
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  baseURL: process.env.VUE_APP_API,
  // baseURL: "ttps://api.trulalala43.com",
  withCredentials: false,
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  (config) => {
    //Authorization

    if (getAccessToken()) {
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
    }

    // if (getSiteKey()) {
    //   config.headers.apikey = `${getSiteKey()}`;
    // } else {
    // Ключ консьюмера Kong. Раньше был зашит в код, поэтому боевой ключ уезжал
    // в собранный бандл и был виден в браузере любому. Теперь берём из окружения,
    // чтобы у прода и стендов ключи были разные.
    config.headers.apikey = process.env.VUE_APP_GATEWAY_KEY;
    // }

    return config;
  },
  // Do something before request is sent f
  (error) => {
    // if (error.response.status === 401) {
    //   logOut();
    // }
    Promise.reject(error);
  },
);

// Add a response interceptor
_axios.interceptors.response.use(
  (response) => {
    const config = response.config;

    // По умолчанию camelCase включен, но если disableCamelCase: true — не применяем
    if (response.data && config.disableCamelCase !== true) {
      response.data = keysToCamelCase(response.data, { deep: true });
    }

    return response;
  },
  async (error) => {
    const originalConfig = error.config;

    if (
      originalConfig.url !== "/user/login" &&
      originalConfig.url !== "/user/refresh" &&
      error.response?.status === 401 &&
      getAccessToken()
    ) {
      if (!originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await _axios.post("/user/login");

          setTokenData(rs.data.data.accessToken, rs.data.data.expiresIn);

          return _axios(originalConfig);
        } catch (_error) {
          logOut();
        }
      }
    }

    // Тоже только если не disableCamelCase
    if (error.response?.data && originalConfig?.disableCamelCase !== true) {
      error.response.data = keysToCamelCase(error.response.data, { deep: true });
    }

    return Promise.reject(error);
  },
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
